/**
 * O contrato de uma tela, e o aviso de erro.
 *
 * Existe como módulo próprio para quebrar um ciclo real: `main.ts` importa as
 * telas para rotear, e cada tela precisava de `Tela` e `avisar` de volta.
 * Bundler tolera ciclo; o custo aparece como ordem de inicialização
 * imprevisível, que é das coisas mais difíceis de depurar num pacote só.
 *
 * Quem depende de quem, agora: `main` → telas → `tela` → `api`.
 */
import { ApiError } from "./api.js";
import { el } from "./dom.js";

export interface Tela {
  titulo: string;
  montar(raiz: HTMLElement): void | Promise<void>;
}

/**
 * Mostra um erro sem derrubar a tela.
 *
 * A mensagem vem da API, que escreve para gente — "Proporção 1080x1080 fora do
 * aceito no feed, de 4:5 a 1.91:1" em vez de "400". Trocar por texto genérico
 * aqui jogaria fora o trabalho que o adapter teve de explicar, e é justamente
 * na hora do erro que a explicação vale.
 */
export function avisar(
  raiz: HTMLElement,
  err: unknown,
  ondeFalhou?: string
): void {
  const msg =
    err instanceof ApiError
      ? err.message
      : err instanceof Error
        ? err.message
        : String(err);

  const box = el(
    "div",
    { class: "aviso erro" },
    el("strong", {}, ondeFalhou ?? "Não deu certo"),
    el("p", {}, msg)
  );

  // 401 aqui quase sempre é sessão vencida. Recarregar leva a página a
  // perguntar /auth/me de novo, receber 401, e mostrar a porta — em vez de a
  // pessoa ficar clicando numa tela que não volta sozinha.
  if (err instanceof ApiError && err.status === 401) {
    box.appendChild(
      el(
        "button",
        { class: "secundario", onclick: () => location.reload() },
        "Entrar de novo"
      )
    );
  }

  raiz.prepend(box);
}
